import { useEffect } from "react";
import { useCookieConsent } from "../hooks/useCookieConsent";
import { initSentry } from "../lib/sentry";

// Gates the Sentry SDK behind the analytics cookie consent.
//
// Mounted inside `CookieConsentProvider` (see `src/index.js`). When the user
// has granted `analytics` consent and a `REACT_APP_SENTRY_DSN` is set at
// build time, this component asks the lazy loader in `src/lib/sentry.js` to
// fetch the Sentry browser SDK from the CDN and call `Sentry.init(...)`.
//
// Idempotent: `initSentry` early-returns if Sentry is already wired up, so
// re-renders are safe.
export default function SentryInitializer({
  dsn = process.env.REACT_APP_SENTRY_DSN,
  environment = process.env.REACT_APP_SENTRY_ENVIRONMENT,
  release = process.env.REACT_APP_SENTRY_RELEASE,
}) {
  const { consent } = useCookieConsent();
  const analyticsEnabled = consent?.analytics === true;

  useEffect(() => {
    if (!analyticsEnabled || !dsn) return;
    initSentry({ dsn, environment, release });
  }, [analyticsEnabled, dsn, environment, release]);

  return null;
}
